import { IContributor, IContributorStats } from '@/types/explorer';
import { normalizeUsername } from '@/utils/strings';
import { apiCall } from '@/utils/api';

export const getContributors = async (
  limit = 100,
  skip = 0,
  sortBy?: string,
  sortAscending?: boolean,
) => {
  const CONTRIBUTORS_ROUTE = '/contributors/';
  try {
    const response: { contributors: IContributor[] } = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${CONTRIBUTORS_ROUTE}` +
        `?limit=${limit}&skip=${skip}&sortBy=${sortBy}&sortAscending=${sortAscending}`,
      {
        method: 'GET',
      },
    );
    return response.contributors;
  } catch (error) {
    return [];
  }
};

export const getContributorStats = async (username: string) => {
  const ROUTE = '/explorer/user/';
  try {
    const response: { stats: IContributorStats } = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}${normalizeUsername(username)}`,
      {
        method: 'GET',
      },
    );
    return response.stats;
  } catch (error) {
    return null;
  }
};

export const getReferrals = async (username: string) => {
  if (!username) {
    return null;
  }
  const ROUTE =
    'https://jxn0m983z9.execute-api.us-west-2.amazonaws.com/prod/referral/user/';

  try {
    const response: { data: any } = await apiCall(
      `${ROUTE}${normalizeUsername(username)}`,
      {
        method: 'GET',
        credentials: 'omit',
      },
    );
    return response.data;
  } catch (error) {
    return null;
  }
};
